var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5764 0.716797H2.58218C1.28096 0.716797 0.22583 1.77192 0.22583 3.07314V10.9266C0.22583 12.2278 1.28096 13.283 2.58218 13.283H13.5764C14.8776 13.283 15.9328 12.2278 15.9328 10.9266V3.07007C15.9328 1.76885 14.8776 0.716797 13.5764 0.716797ZM13.2565 2.28564L8.63608 6.90298C8.33154 7.2106 7.8332 7.21367 7.52559 6.90606L7.52251 6.90298L2.9021 2.28564H13.2565ZM14.3639 10.9266C14.3639 11.3604 14.0132 11.711 13.5795 11.711H2.58218C2.14844 11.711 1.79775 11.3604 1.79775 10.9266V3.39307L6.41509 8.0104C7.33486 8.93018 8.82373 8.93018 9.74658 8.0104L14.3639 3.39307V10.9266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.390356c539e4a47d158d4a160d0a40a5.svg";
export { ForwardRef as ReactComponent };